import type { IProductCategory } from '@percent/cause-dashboard/app/productOffers/data/categories'
import { Loader } from '@percent/cause-dashboard/common/components'
import { useProductOffersPageStory } from '@percent/cause-dashboard/storyblok/product-offers/useProductOffersPageStory'
import { useTranslation } from 'react-i18next'
import { EmptyState } from '../common/components/emptyState/EmptyState'
import { ProductOffersPageContent } from './ProductOffersPageContent'
import { ProductOffersPageStoryBridge } from './ProductOffersPageStoryBridge'

interface ProductOffersPageProps {
  offersOverride?: Array<{ id: number } & IProductCategory>
}

export function ProductOffersPage({ offersOverride }: Readonly<ProductOffersPageProps>) {
  const { t } = useTranslation()
  const storyblokEnabled = !offersOverride
  const storyQuery = useProductOffersPageStory(storyblokEnabled)

  if (offersOverride) {
    return <ProductOffersPageContent categorizedProducts={offersOverride} />
  }

  if (storyQuery.loading) {
    return <Loader isFullScreen />
  }

  if (storyQuery.error || !storyQuery.story) {
    return (
      <EmptyState
        illustration="no-search-results"
        title={t('productOffers.unavailableTitle')}
        description={t('productOffers.unavailableDescription')}
      />
    )
  }

  return <ProductOffersPageStoryBridge initialStory={storyQuery.story} />
}
